/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { LinkButton } from '@blend/enterprise-components';
import { useFormState } from 'react-final-form';
import { useHistory } from 'react-router';

// used by caliper
const ID_FORGOT_PASSWORD = 'it-ForgotPassword';

export namespace ForgotPasswordLinkButton {
  export interface Props {
    usernameFromParams?: string;
  }
}

export const ForgotPasswordLinkButton: React.FC<ForgotPasswordLinkButton.Props> = ({ usernameFromParams }) => {
  const {
    values: { username },
  } = useFormState<{ username: string }>();
  const userEmail = usernameFromParams || username;
  const history = useHistory();
  return (
    <LinkButton
      id={ID_FORGOT_PASSWORD}
      includeInFullStory={true}
      label="Forgot Password?"
      onClick={() =>
        history.push({
          pathname: `/client/forgot-password`,
          search: userEmail ? `username=${userEmail}` : ``,
        })
      }
    />
  );
};
